import classNames from 'clsx';
import PropTypes from 'prop-types';
import SeekSlider from './SeekSlider';
import css from './scrubber.module.scss';

export default function DefaultScrubber({
  isLive,
  sliderMax,
  elapsedTime,
  durationTime,
  elapsedPercent,
  elapsedSeconds,
  onChangeCommitted,
  isInNowPlayingDialog,
  className,
}) {
  const showTimestamps = !isLive;
  const elapsedCss = isInNowPlayingDialog ? css.nowPlayingElapsed : css.elapsed;
  const durationCss = isInNowPlayingDialog ? css.nowPlayingDuration : css.duration;
  const elapsed = !isLive ? elapsedPercent : 0;

  return (
    <div
      data-testid="scrubberWrapper"
      className={classNames(className, {
        [css.scrubberContainer]: isInNowPlayingDialog,
      })}
    >
      {showTimestamps && (
        <div data-testid="elapsedWrapper" className={elapsedCss}>
          <span data-elapsedtime={elapsedSeconds} id="scrubberElapsed">
            {elapsedTime}
          </span>
        </div>
      )}
      <SeekSlider
        disabled={isLive}
        elapsedPercent={elapsed}
        sliderMax={sliderMax}
        onChangeCommitted={onChangeCommitted}
        isInNowPlayingDialog={isInNowPlayingDialog}
      />
      {showTimestamps && (
        <div id="scrubberDuration" className={durationCss}>
          {durationTime}
        </div>
      )}
    </div>
  );
}

DefaultScrubber.propTypes = {
  elapsedPercent: PropTypes.number.isRequired,
  elapsedSeconds: PropTypes.number.isRequired,
  sliderMax: PropTypes.number.isRequired,
  durationTime: PropTypes.string,
  elapsedTime: PropTypes.string.isRequired,
  onChangeCommitted: PropTypes.func.isRequired,
  isInNowPlayingDialog: PropTypes.bool,
  className: PropTypes.string,
};
